module.exports = {
  adminDomain: '',
  allowStubs: false,
  apiPath: '/api',
  assetsPath: '/assets',
  cfDomain: '',
  cmsDirectory: '/bin/v1',
  contentRoot: '/content/dam/waitrosegroceriescms',
  failsafe: true,
  features: {
    adtechMenuBanners: false,
    apmRum: false,
    apmRumErrorLogging: false,
    browse_mealDealEndDate1Day: false,
    browse_mealDealEndDate2Day: false,
    browse_mealDealEndDateToday: false,
    browse_offersLinksWithRelNofollow: false,
    checkout_disableContentsquare: false,
    checkout_disableCSP: false,
    checkout_excludeExternal: false,
    checkout_giftCardv3: false,
    checkout_wismo: false,
    cspCheckoutEnforceRules: false,
    cspCheckoutScriptUnsafeEval: false,
    designSystem_brandWorldTypography: false,
    eagerSuggest: false,
    enablePredictiveAddress: false,
    EoS_interstitialsAnalytics: false,
    EoS_searchHardReload: false,
    glpNLPCarousel: false,
    loyalty_competitions: true,
    loyalty_enableNonIPickSelection: false,
    manualAddressFormOnly: true,
    modalErrorLogging: false,
    multisearch: true,
    nlpCarousel: false,
    onlineClipToCard: false,
    orderItemSubs: false,
    podHighlight: false,
    recommendationsWithFallback: false,
    renderStaticNavLinks: false,
    savePaymentCard: true,
    searchHistory: true,
    sentry: false,
    sentryContentsquare: false, // Contentsquare integration only works if sentry is true
    showPlasticCardDelayAlert: false,
    showPrideLogo: false,
    siteBanner: false,
    slots_allDeliverySlotsDisabled: false,
    slots_allSlotsDisabled: false,
    slots_newSlotConfirmationMessage: false,
    slots_useCustomCampaign: false,
    ssrForAll: false,
    throttleLogins: false,
    trolley_christmasHeaderForceValidDate: false,
    agenticShopping_enableCrossChannelUpload: false,
    agenticShopping_enableListToBasket: false,
    agenticShopping_enableViewAllModal: false,
  },
  featureFlagsToPassToAPI: ['enAppleWallet'],
  googleAnalytics: {
    collectApiUrl: 'https://sst.waitrose.com/data',
    measurementId: 'G-20C100JG1P',
  },
  graphPath: '/graph',
  impactTrackerId: '22892',
  johnLewisServerPath: 'https://api.integration.project4.com/',
  walletPassesServerPath: 'https://wtr-wec-acpt.waitrose.com/',
  loyaltyExperiencesServerPath: 'https://integration-api.loyalty-experiences.flex.jl-digital.net',
  johnLewisGiftingServerPath: 'https://integration-gifter.gifting.flex.jl-digital.net',
  ofDomain: '',
  monetateApiChannel: 'a-18da6672/d/dev.waitrose.com',
  cardinalScriptV2Url: 'https://cas.static.client.cardinaltrusted.com/songbird/v2.1.3/songbird.js',
  cardinalScriptV2Integrity:
    'sha384-WllJleM4xfVYLyRUgxxtAAPgfD5U3ursxM52cfjCyEEmRq1prDGuHVQykhNFIgkb',
  kountClientID: '888099',
  paymentCardAuthReturn: '/v1/orders/payments/authentication',
  prodHost: 'www.waitrose.com',
  verifoneDomain: 'https://sandbox.omni.verifone.cloud/v1',
  verifoneOrganizationID: '5d15d6671a8e7b2d3a83cc5a',
  reCaptchaPublicKey: '6LfbWzEaAAAAALZVveWFuQj_9sLLIzGYfuw4VPK8',
  root: '/ecom',
  thirdPartyPath: '/external',
  timeouts: {
    interstitials: {
      response: 2000,
      deadline: 4000,
    },
    minimumOrderValues: {
      response: 5000,
      deadline: 7000,
    },
  },
  verifoneCardFormPostUrl: 'https://vg-cst.cxmlpg.com/vanguard.aspx',
  wcsDomain: '',
  authDomain: '',
  tokenExScriptUrl: 'https://api.tokenex.com/inpage/js/TokenEx-Lite.js',
  tokenExPublicKey:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvWpIQFjQQCPpaIlJKpegirp5kLkzLB1AxHmnLk73D3TJbAGqr1QmlsWDBtMPMRpdzzUM7ZwX3kzhIuATV4Pe7RKp3nZlVmcrT0YCQXBrTwqZNh775z58GP2kZs+gVfNqBampJPzSB/hB62KkByhECn6grrRjiAVwJyZVEvs/2vrxaEpO+aE16emtX12RgI5JdzdOiNyZEQteU6zRBRJEocPWVxExaOpVVVJ5+UnW0LcalzA+lRGRTrQJ5JguAPiAOzRPTK/lYFFpCAl/F8wtoAVG1c8zO2NcQ0Pko+fmeidRFxJ/did2btV+9Mkze3mBphwFmvnxa35LF+Cs/XJHDwIDAQAB',
  recipesPerPage: 54,
  sitemapRecipesCategories:
    'https://waitrose-prod65.adobecqms.net/content/waitrosegroceriescms/en/recipes.sitemap.recipes.categories.xml',
  sitemapRecipesDetailPages:
    'https://apie-eu-west-1.ecom.waitrose.com/recipes-prod/v1/sitemap.recipe.detail.pages.xml',
  version: process.env.VERSION,
  apmRum: {
    url: 'https://wtr-ecom-logging-nonprod.apm.eu-west-1.aws.found.io',
    transactionSampleRate: 1.0,
  },
  contentsquare: {
    scriptUrl: `https://t.contentsquare.net/uxa/115ab44117fcc.js`,
  },
  sitemapContentPages:
    'https://waitrose-prod.adobecqms.net/content/waitrosegroceriescms/en/wtr-content.sitemap.contentpage.xml',
};
